//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';

import { useAuth } from './BasicAuth';
import * as choiceApi from '../api/choice';

export function LoginPanel() {
    const [username, setUserName] = useState(process.env.REACT_APP_MEMBER_NUMBER ?? "");
    const [password, setPassword] = useState(process.env.REACT_APP_PASSWORD ?? "");
    const [msg, setMsg] = useState("");

    let navigate = useNavigate();
    let location = useLocation();

    let goToPage = location?.state?.from?.pathname ?? location.pathname;
    let auth = useAuth();

    const onSubmit = async (e) => {
        e.preventDefault();

        try {
            const userInfo = await choiceApi.login(username, password);
            // console.log(userInfo);
            auth.signin(userInfo, () => {
                navigate(goToPage, { replace: true });
            })
        }
        catch (err) {
            console.log(err);
            setMsg(err?.response?.data?.message)
            setPassword("");
        }
    }


    const showLogin = (location.hash === "#signin");

    const alert = msg ? <Alert className="mt-3" variant="danger">{msg}</Alert> : null;

    return (
        <Offcanvas className="login-panel" show={showLogin} placement="end" onHide={() => navigate(-1)}>
            <Offcanvas.Header closeVariant="white" closeButton>
                <Offcanvas.Title></Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="p-4">
                    <div className="d-flex flex-column justify-content-between h-100">
                        <div>
                            <h1>Welcome Back!</h1>

                            {alert}
                            <Form onSubmit={onSubmit}>

                                <div className='mt-3'>Membership ID</div>
                                <FormControl value={username} onChange={(e) => setUserName(e.target.value)} />

                                <div className='mt-3'>Password</div>
                                <FormControl type="password" value={password} onChange={(e) => setPassword(e.target.value)} />

                                <div className='mt-4'>
                                    <Button className='w-100' type='submit'>Sign In</Button>
                                </div>
                            </Form>
                        </div>

                        <div>
                            <div className="d-flex justify-content-between">
                                <Link className='w-100' to='#reset-password' replace><Button className='w-100' variant="outline-primary">Reset Password</Button></Link>
                            </div>
                            
                        </div>

                    
                    </div>


            </Offcanvas.Body>
        </Offcanvas>
    )

}